/* GANGALY v2: movimiento con intención (~3 KB, sin librerías). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1) Sello giratorio "Paga al recibir" sobre la foto principal
  var n = 0;
  function stamp() {
    var id = 'codp' + (n++);
    return '<div class="cod-stamp" aria-hidden="true"><svg class="cod-stamp__ring" viewBox="0 0 100 100">' +
      '<circle class="cod-stamp__bg" cx="50" cy="50" r="50"/>' +
      '<defs><path id="' + id + '" d="M50,50 m-38,0 a38,38 0 1,1 76,0 a38,38 0 1,1 -76,0"/></defs>' +
      '<text><textPath href="#' + id + '" textLength="236" lengthAdjust="spacing">PAGA AL RECIBIR • ENVÍO GRATIS •</textPath></text>' +
      '</svg><div class="cod-stamp__core">PAGA<br>AL<br>RECIBIR</div></div>';
  }
  document.querySelectorAll('.hero__media, [data-main-media]').forEach(function (el) {
    if (!el.querySelector('.cod-stamp')) el.insertAdjacentHTML('beforeend', stamp());
  });

  // 2) Botones intermedios: abren el formulario contraentrega (Releasit) o suben al de compra
  function openCod() {
    var app = document.querySelector('[data-cod-trigger], #_rsi-cod-form-button, .releasit-button, .es-form-button');
    if (app) { app.click(); return true; }
    var f = document.getElementById('product-form');
    if (f) { f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return true; }
    return false;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-scroll-buy]');
    if (b && document.querySelector('[data-product]') && openCod()) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // 3) Recibo: fechas de llegada reales (2 a 5 días hábiles desde hoy)
  var rc = document.querySelector('[data-receipt]');
  if (rc) {
    var eta = rc.querySelector('[data-receipt-eta]');
    var sel = rc.querySelector('[data-receipt-city]');
    function addBiz(d, k) { d = new Date(d); while (k > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k--; } return d; }
    function fmt(d) { return d.toLocaleDateString('es-CO', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); }
    function upd() {
      var far = sel && sel.value === 'far';
      var now = new Date();
      eta.style.opacity = 0;
      setTimeout(function () {
        eta.textContent = far ? 'Desde el ' + fmt(addBiz(now, 3)) + ' (municipios lejanos pueden tardar más)' : 'Entre el ' + fmt(addBiz(now, 2)) + ' y el ' + fmt(addBiz(now, 5));
        eta.style.opacity = 1;
      }, reduce ? 0 : 180);
    }
    if (sel) sel.addEventListener('change', upd);
    upd();
  }

  // 4) Título principal: línea que sube desde una máscara (solo al cargar)
  if (!reduce) {
    var t = document.querySelector('.product__title, .hero h1');
    if (t && !t.querySelector('.mask-line')) { t.innerHTML = '<span class="mask-line"><span>' + t.innerHTML + '</span></span>'; }
  }

  // 5) Frase grande: las palabras se llenan de tinta al bajar
  document.querySelectorAll('[data-ink]').forEach(function (p) {
    var words = p.textContent.trim().split(/\s+/);
    p.innerHTML = words.map(function (w) { return '<span class="w">' + w + '</span>'; }).join(' ');
    if (reduce) return;
    var ws = p.querySelectorAll('.w');
    var tick = false;
    function fill() {
      var r = p.getBoundingClientRect(), vh = window.innerHeight;
      var prog = Math.min(Math.max((vh * 0.85 - r.top) / (r.height + vh * 0.4), 0), 1);
      var k = Math.round(prog * ws.length);
      ws.forEach(function (w, i) { w.classList.toggle('on', i < k); });
      tick = false;
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(fill); } }, { passive: true });
    fill();
  });

  // 6) Entradas por sección, en orden de lectura (una vez, solo bajo el pliegue)
  if (reduce || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('js');
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' });
  var vh = window.innerHeight;
  function tag(sel, cls, stagger) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) return;
      if (stagger) el.style.setProperty('--i', Math.min(Array.prototype.indexOf.call(el.parentNode.children, el), 5));
      el.classList.add(cls); io.observe(el);
    });
  }
  tag('.section__head, .cta-banner h2, .cta-banner p, .receipt', 'rv-up', false);
  tag('.steps li, .faq, .grid--products > *, .compare tbody tr', 'rv-up', true);
  tag('.iwt__media img, .story__chapter:not(.story__chapter--open) .story__frame > *', 'rv-pic', false);
  tag('.story__line, .iwt__text', 'rv-up', false);
})();
